import { Card, Col, Row, Select, Tag, Typography } from 'antd';
import { ArrowUpOutlined, ArrowDownOutlined, MinusOutlined } from '@ant-design/icons';
import { useState } from 'react';
import { CITY_STATS, CityStat } from '../api/surveys';

const { Title, Text } = Typography;

const CITIES = ['Bangkok', 'Chiang Mai', 'Phuket'];
const CAT_COLORS: Record<string, string> = {
  Environment: 'green', Food: 'orange', Transport: 'blue', Community: 'purple',
};

function TrendIcon({ trend }: { trend: CityStat['trend'] }) {
  if (trend === 'up') return <ArrowUpOutlined style={{ color: '#52c41a' }} />;
  if (trend === 'down') return <ArrowDownOutlined style={{ color: '#ff4d4f' }} />;
  return <MinusOutlined style={{ color: '#999' }} />;
}

export default function CityStats() {
  const [city, setCity] = useState('Bangkok');
  const [cat, setCat] = useState('All');

  const categories = ['All', ...Array.from(new Set(CITY_STATS.map(s => s.category)))];
  const filtered = cat === 'All' ? CITY_STATS : CITY_STATS.filter(s => s.category === cat);

  return (
    <div style={{ padding: 24 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: 8 }}>
        <Title level={3} style={{ margin: 0 }}>City Statistics</Title>
        <div style={{ display: 'flex', gap: 12 }}>
          <Select value={city} onChange={setCity} style={{ width: 150 }}>
            {CITIES.map(c => <Select.Option key={c} value={c}>{c}</Select.Option>)}
          </Select>
          <Select value={cat} onChange={setCat} style={{ width: 160 }}>
            {categories.map(c => <Select.Option key={c} value={c}>{c}</Select.Option>)}
          </Select>
        </div>
      </div>
      <Text type="secondary" style={{ display: 'block', marginBottom: 24 }}>
        Key indicators for {city} — updated monthly from community surveys and open data sources.
      </Text>

      <Row gutter={[16, 16]}>
        {filtered.map(stat => (
          <Col key={stat.label} xs={24} sm={12} lg={8}>
            <Card hoverable>
              <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                <div>
                  <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 8 }}>
                    <span className="material-icons" style={{ fontSize: 20, color: '#1677ff' }}>{stat.icon}</span>
                    <Tag color={CAT_COLORS[stat.category] ?? 'default'} style={{ fontSize: 11 }}>{stat.category}</Tag>
                  </div>
                  <div style={{ fontSize: 28, fontWeight: 800, lineHeight: 1 }}>
                    {stat.value}
                    <span style={{ fontSize: 14, fontWeight: 400, color: '#999', marginLeft: 4 }}>{stat.unit}</span>
                  </div>
                  <div style={{ marginTop: 4, fontSize: 13, color: '#666' }}>{stat.label}</div>
                </div>
              </div>
              <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 6, fontSize: 12, color: '#999' }}>
                <TrendIcon trend={stat.trend} />
                {stat.trendValue}
              </div>
            </Card>
          </Col>
        ))}
      </Row>

      <Card style={{ marginTop: 24, background: '#f6ffed', borderColor: '#b7eb8f' }}>
        <Text strong>Data sources</Text>
        <Text type="secondary" style={{ display: 'block', marginTop: 4, fontSize: 12 }}>
          Statistics are compiled from UrbanLife.Works community surveys, Bangkok Metropolitan Administration open data,
          and self-reported data from registered farmers and businesses on the platform.
          Statistics are indicative and updated monthly.
        </Text>
      </Card>
    </div>
  );
}
